define((require) => {
    "use strict";

    var $        = require("jquery"),
        _        = require("underscore"),
        Backbone = require("backbone"),
        Comment  = require("ui/comments/Comment"),
        RestApi  = require("shared/services/RestApi");

    // TODO: This collection should be proper implementated (#url()) http://backbonejs.org/#Collection

    /**
     * A collection of comments.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentCollection
     * @constructor
     */
    var CommentCollection = Backbone.Collection.extend({

        model: Comment,

        /**
         * @private
         *
         * Constructs a new comment, attaching the sceneID passed in the options object.
         *
         * @param  {Object} modelData The raw JSON model data.
         * @param  {Object} options   The options object passed.
         * @return {Comment}           A new Comment instance.
         */
        _newComment: function(modelData, options) {
            var comment = new Comment(modelData);
            comment.sceneID = options.sceneID;
            return comment;
        },

        parse: function(response, options) {
            var self = this;

            if (_.isArray(response)) {
                return _.map(response, (modelData) => {
                    return self._newComment(modelData, options);
                });
            }

            return this._newComment(response, options);
        },

        getCommentsForScene: function(sceneID) {
            return this.filter((comment) => {
                return comment.sceneID === sceneID;
            });
        }

    }, {

        fetchCommentsFor: function(experienceId) {
            return $.getJSON(RestApi.pathToCollectionOnResource(RestApi.Collections.EXPERIENCES, experienceId, RestApi.Collections.COMMENTS));
        },

        /**
         * Computes the number of comments posted since the specified date.
         *
         * @param  {String} experienceId The experience Id.
         * @param  {Number} time         The server time to check since.
         * @return {Promise} A pormise that will be resolved with the computed number of comments.
         */
        countCommentsSince: function(experienceId, time) {
            var counter = 0,
                since = function(comment) {
                    return comment.createdAt > time;
                };

            return CommentCollection.fetchCommentsFor(experienceId)
                .then((commentsData) => {
                    _.each(commentsData, (sceneCommentsJSON) => {
                        _.each(sceneCommentsJSON, (comment) => {
                            if (since(comment)) {
                                counter++;
                            }
                            _.each(comment.replies, (reply) => {
                                if (since(reply)) {
                                    counter++;
                                }
                            });
                        });
                    });

                    return counter;
                });
        }

    });

    return CommentCollection;
});



// WEBPACK FOOTER //
// ./src/editor/ui/comments/CommentCollection.js